import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/feature/BackToTop';
import FacebookFollow from '@/components/feature/FacebookFollow';
import HeroSection from './components/HeroSection';
import QuickInfoSection from './components/QuickInfoSection';
import AboutSection from './components/AboutSection';
import ReasonsSection from './components/ReasonsSection';
import MenuSection from './components/MenuSection';
import CinematicSection from './components/CinematicSection';
import GallerySection from './components/GallerySection';
import ExperienceSection from './components/ExperienceSection';
import ContactSection from './components/ContactSection';
import CtaSection from './components/CtaSection';
import OpeningHoursSection from './components/OpeningHoursSection';

export default function Home() {
  return (
    <>
      <Navbar />

      <main>
        <HeroSection />
        <QuickInfoSection />
        <AboutSection />
        <ReasonsSection />
        <MenuSection />
        <CinematicSection />
        <GallerySection />
        <ExperienceSection />
        <ContactSection />
        <CtaSection />
        <OpeningHoursSection />
        <FacebookFollow />
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}